import { FileText } from 'lucide-react'

import { AccessDeniedState } from '@/components/shared/access-denied-state'
import { Empty, EmptyDescription, EmptyMedia } from '@/components/ui/empty'
import { isPermissionDeniedError } from '@/lib/error-reporting'

/**
 * Server-truth branch for the quote detail query's error state: a
 * PermissionDenied error (stale `can()` cache, or a permission that was
 * never checked proactively) gets the RBAC lock state; every other failure
 * keeps the existing generic "couldn't load" state.
 */
export function QuoteDetailErrorState({ error }: { error: unknown }) {
  if (isPermissionDeniedError(error)) {
    return <AccessDeniedState variant="page" noun="quotes" />
  }

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <Empty className="flex-1 border border-dashed py-12">
        <EmptyMedia variant="icon">
          <FileText className="h-6 w-6" />
        </EmptyMedia>
        <EmptyDescription>We couldn't load this quote right now.</EmptyDescription>
      </Empty>
    </div>
  )
}
